"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Manage = function Manage(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "ManageTitle ManageDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "ManageTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "ManageDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(0.75 0.75)",
    d: "M31.489 6.893l-1.333-1.569a1.64 1.64 0 0 0-2.312-.173L26.164 6.6l-5.75 4.942h-8.89v1.111h7.587l-3.275 2.818-.494 2.969h-3.818v1.102h7.805l10.307-8.889 1.68-1.444a1.644 1.644 0 0 0 .173-2.316zM18.924 18.41h-2.44l.396-2.382 9.142-7.867 2.05 2.378-9.148 7.87zM30.591 8.36l-1.68 1.449-2.04-2.369 1.68-1.449a.529.529 0 0 1 .742.058l1.356 1.569a.529.529 0 0 1-.058.742zm-2.769 15.662l-.009-8.715h1.111v8.715a3.8 3.8 0 0 1-3.795 3.791H1.667V2.796h22.009v1.11H2.786V26.69h22.37a2.667 2.667 0 0 0 2.666-2.667zM7.924 10.818a1.262 1.262 0 1 1 0 2.524 1.262 1.262 0 0 1 0-2.524zm0 6.893a1.267 1.267 0 1 1-.008 2.533 1.267 1.267 0 0 1 .008-2.533z",
    id: "refManageRBXToJqJ6a4"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#refManageRBXToJqJ6a4"
  }));
};

Manage.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Manage.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Manage;
exports["default"] = _default;